import React from 'react';
import './index.scss';
import { Button } from 'antd';

type IProps = Readonly<{
    onHandleCancel?: () => void;
    text: string;
}>;

export function CancelButton(props: IProps) {
    const { onHandleCancel, text } = props;
    return (
            <Button className="Button-cancel" onClick={onHandleCancel}>{text}</Button>
    )
}